import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { PostalAddressInput } from '__generated__/globalTypes';
import { PostalAddressForm } from 'components/settings/PostalAddressForm';
import { useMutation } from 'hooks/graphql/useMutation';

import type {
  UpdateUserPostalAddressMutation,
  UpdateUserPostalAddressMutationVariables,
} from './__generated__/useUpdateUserPostalAddress.graphql';

const UPDATE_POSTAL_ADDRESS_MUTATION = gql`
  mutation UpdateUserPostalAddressMutation($input: updateUserSettingsInput!) {
    updateUserSettings(input: $input) {
      currentUser {
        slug
        userSettings {
          id
          ...PostalAddressForm_userSettings
        }
      }
      errors {
        path
        message
        code
      }
    }
  }
  ${/* eslint-disable-next-line sorare/no-detached-fragments */ ''}
  ${PostalAddressForm.fragments.userSettings}
` as TypedDocumentNode<
  UpdateUserPostalAddressMutation,
  UpdateUserPostalAddressMutationVariables
>;

export const useUpdateUserPostalAddress = () => {
  const [mutate] = useMutation(UPDATE_POSTAL_ADDRESS_MUTATION);

  return async (postalAddress: PostalAddressInput) =>
    mutate({
      variables: {
        input: {
          postalAddress,
        },
      },
    });
};
